<template>
  <div>
    <v-data-table
      :headers="displayHeaders"
      :items="items"
      :rows-per-page-items="[10]"
      hide-actions
      item-key="id"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <td>{{ shipment.doNo }}</td>
        <td>{{ props.item.branchCode }}</td>
        <!-- <td>{{ props.item.containerNo }}</td>
        <td>{{ props.item.containerTypeName }}</td>-->
        <!-- <td>{{ props.item.chargeItemName }}</td> -->

        <td
          :class="{'text-xs-right':header.align==='right'}"
          :key="header.col"
          v-for="header in displayHeaders"
          v-show="header.show"
        >
          <span
            v-if="header.value === 'chargeItemScreenStatistics'"
          >{{ props.item.chargeItemScreenStatistics }}</span>
          <span v-if="header.value === 'chargeItemName'">{{ props.item.chargeItemName }}</span>
          <span v-if="header.value === 'subTotal'">{{props.item.subTotal|currency}}</span>
          <span v-if="header.value === 'currencyCode'">{{props.item.currencyCode}}</span>
          <span
            v-if="header.value === 'consumptionTaxCode'"
          >{{props.item.consumptionTaxRate>0?'課税':'免税'}}</span>
          <span v-if="header.value === 'currencyRate'">{{ props.item.currencyRate }}</span>
          <span v-if="header.value === 'supplierName'">{{ props.item.supplierName }}</span>
          <span v-if="header.value === 'jpyTaxTotalNoTax'">{{ props.item.jpySubTotal|currency }}</span>
          <span v-if="header.value === 'jpyTotal'">{{ props.item.jpyTotal|currency }}</span>
          <span
            v-if="header.value === 'jpySubTotal'"
          >{{ props.item.jpySubTotal|currency({fractionCount:0}) }}</span>
          <span v-if="header.value === 'jpyTaxTotal'">{{ props.item.jpyTaxTotal|currency }}</span>
          <span v-if="header.value === 'comment'">{{props.item.comment}}</span>
          <span v-if="header.value === 'status'">{{ props.item.showStatus }}</span>

          <v-tooltip bottom>
            <span
              @mouseout="closeContainerNoDetail"
              @mouseover="showContainerNoDetail(props.item.containerNo)"
              class="container"
              slot="activator"
              v-if="header.value === 'containerNo'"
            >{{ containerNos(props.item.containerNo) }}</span>
            <span>{{ currentContainerNos }}</span>
          </v-tooltip>

          <span v-if="header.value === 'containerTypeName'">{{ props.item.containerTypeName }}</span>

          <span
            v-if="header.value === 'showPaymentSubTotal'"
          >{{props.item.showPaymentSubTotal|currency}}</span>
          <span
            v-if="header.value === 'showPaymentJpySubTotal'"
          >{{props.item.showPaymentJpySubTotal|currency({fractionCount:0}) }}</span>
          <span
            v-if="header.value === 'showPaymentJpySubTotalNoTax'"
          >{{props.item.showPaymentJpySubTotal|currency }}</span>
          <span
            v-if="header.value === 'showPaymentJpyTaxTotal'"
          >{{props.item.showPaymentJpyTaxTotal|currency }}</span>
        </td>
      </template>
    </v-data-table>
    <div style="display:flex; padding:10px; float:right">
      <div style="margin-right:40px;" v-if="hasDrake">ドレージ総計:{{ drakeTotal }}</div>
      <div v-if="hasDevan">デバン料総計:{{ devanTotal }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shipment: Object,
    supplierId: String,
    columns: String,
    ignoreSupplier: { type: Boolean, default: false },
    showCheckBox: { type: Boolean, default: false }
  },
  data() {
    return {
      selected: [],
      dialog: false,
      currentContainerNos: null,
      headers: [
        {
          text: 'DoNo',
          value: 'doNo',
          sortable: false,
          col: '15',
          show: false
        },
        {
          text: '枝番',
          value: 'branchCode',
          sortable: false,
          col: '16',
          show: false
        },
        {
          text: 'コンテナNO',
          value: 'containerNo',
          sortable: false,
          col: '18',
          show: true
        },
        {
          text: 'コンテナサイズ',
          value: 'containerTypeName',
          sortable: false,
          col: '19',
          show: true
        },
        {
          text: '費用項目',
          value: 'chargeItemName',
          sortable: false,
          col: '17',
          show: true
        },
        {
          text: '費用項目',
          value: 'chargeItemScreenStatistics',
          sortable: false,
          col: '0',
          show: true
        },
        {
          text: '金額',
          value: 'subTotal',
          sortable: false,
          align: 'right',
          col: '1',
          show: true
        },
        {
          text: '通貨',
          value: 'currencyCode',
          sortable: false,
          col: '2',
          show: true
        },
        {
          text: '税区分',
          value: 'consumptionTaxCode',
          sortable: false,
          col: '3',
          show: true
        },
        {
          text: 'レート',
          value: 'currencyRate',
          sortable: false,
          align: 'right',
          col: '4',
          show: true
        },
        {
          text: '支払先',
          value: 'supplierId',
          sortable: false,
          col: '5',
          show: true
        },
        {
          text: '円換算税抜金額',
          value: 'jpyTaxTotalNoTax',
          sortable: false,
          align: 'right',
          col: '6',
          show: true
        },
        {
          text: '円換算税金金額',
          value: 'jpyTaxTotal',
          sortable: false,
          align: 'right',
          col: '7',
          show: true
        },
        {
          text: 'コメント',
          value: 'comment',
          sortable: false,
          col: '8',
          show: true
        },
        {
          text: 'ステータス',
          value: 'status',
          sortable: false,
          col: '9',
          show: true
        },
        {
          text: '換算金額',
          value: 'jpySubTotal',
          sortable: false,
          align: 'right',
          col: '10',
          show: true
        },
        {
          text: '金額',
          value: 'showPaymentSubTotal',
          sortable: false,
          align: 'right',
          col: '11',
          show: true
        },
        {
          text: '換算金額',
          value: 'showPaymentJpySubTotal',
          sortable: false,
          align: 'right',
          col: '12',
          show: true
        },
        {
          text: '円換算税抜金額',
          value: 'showPaymentJpySubTotalNoTax',
          sortable: false,
          align: 'right',
          col: '13',
          show: true
        },
        {
          text: '円換算税金金額',
          value: 'showPaymentJpyTaxTotal',
          sortable: false,
          align: 'right',
          col: '14',
          show: true
        }
      ]
    }
  },
  computed: {
    hasDevan() {
      return this.items.filter(i => i.chargeItemCode === 'LOCAL-008').length > 0
    },
    hasDrake() {
      return this.items.filter(i => i.chargeItemCode === 'LOCAL-001').length > 0
    },
    devanTotal() {
      return this.items
        .filter(i => i.chargeItemCode === 'LOCAL-008')
        .reduce((t, i) => {
          return t + i.paymentJpySubTotal + i.paymentJpyTaxTotal
        }, 0)
    },
    drakeTotal() {
      return this.items
        .filter(i => i.chargeItemCode === 'LOCAL-001')
        .reduce((t, i) => {
          return t + i.paymentJpySubTotal + i.paymentJpyTaxTotal
        }, 0)
    },
    items() {
      if (this.ignoreSupplier) {
        return this.shipment && this.shipment.summaryCharges
      } else {
        return (
          this.shipment &&
          this.shipment.summaryCharges &&
          this.shipment.summaryCharges
            .filter(s => s.supplierId === this.supplierId)
            .sort((a,b)=>this.isNull(a.branchCode).localeCompare(b.branchCode))
        )
      }
    },
    displayHeaders() {
      if (this.columns) {
        return this.columns
          .split(',')
          .map(c => this.headers.find(h => h.col === c))
      } else {
        return this.headers
      }
    }
  },
  methods: {
    isNull(item) {
      return item || ''
    },
    adjustSupplier() {
      if (this.selected.length == 0) {
        this.$message('ERROR', '少なくとも1つの送料を選択してください')
      } else {
        this.$emit('adjust', this.selected)
      }
    },
    containerNos(item) {
      if (item.split(',').length <= 3) {
        return item
      } else {
        // return item
        return '......'
      }
    },
    showContainerNoDetail(item) {
      this.dialog = true
      this.currentContainerNos = item
    },
    closeContainerNoDetail() {
      this.dialog = false
      this.currentContainerNos = null
    }
  }
}
</script>